export const tabEnmu = {
  dashboard: '0',
  hostes: '1',
  subAgent: '2',
}
